import {DetailedHTMLProps, HTMLProps, ReactNode} from "react"
import {classNames} from "@/library/utilities/html"

type InputGroupProps = {
    label?: string
    placeholder?: string
    buttonLeft?: ReactNode
    buttonRight?: ReactNode
    inputElement?: ReactNode
} & DetailedHTMLProps<HTMLProps<HTMLLabelElement>, HTMLLabelElement>

export default function InputGroup(props: InputGroupProps) {
    const {className = '', label, placeholder, buttonLeft, buttonRight, inputElement, ...divProps} = props

    return <label {...divProps} className={classNames(
        "input-group", className
    )}>
        {label && <span>{label}</span>}
        <div className="control-group">
            {buttonLeft && buttonLeft}
            {inputElement && inputElement}
            {buttonRight && buttonRight}
        </div>
    </label>
}
